module.exports = __webpack_public_path__ + "img/logo-light-icon.723f7487.png";